import { createMinuteDropdownOptions } from '@acorn-portal/shared/src/utils/create-minute-dropdown-options';
import { TimeContext } from './get-current-time-context';
import { MinuteIncrement } from './types';

/**
 * Generates dynamic minute dropdown options based on the current time context.
 *
 * When the selected hour is the current hour, restricts available minutes to future times only.
 * For non-current hours, returns all minute options based on the specified increment.
 *
 * @param timeContext - The current time context containing current hour and next valid minute
 * @param minuteIncrement - The increment between minute options (e.g. 15 for 0, 15, 30, 45)
 * @param selectedHour - The hour selected by the user (optional)
 * @returns Array of minute dropdown options
 */
export const getMinuteOptionsFromNow = (
	timeContext: TimeContext,
	minuteIncrement: MinuteIncrement,
	selectedHour?: string,
) => {
	const { currentHour, nextValidMinute } = timeContext;

	// For non-current hours, return all standard minute options
	const isCurrentHourSelected = selectedHour && +selectedHour === currentHour;
	if (!isCurrentHourSelected) return createMinuteDropdownOptions(minuteIncrement);

	// For current hour, restrict to future minutes only
	// If next valid minute > 60, we've rolled over to next hour, so reset to 0
	const minMinute = nextValidMinute > 60 ? 0 : nextValidMinute;
	// Add 1 to prevent selecting the current minute (ensuring future time selection)
	return createMinuteDropdownOptions(minuteIncrement, minMinute);
};
